// SF custom: wishlist for logged-in customers (replaces Swym).
//
// Hearts: snippets/sf-wishlist-button.liquid. Page: sections/sf-wishlist.liquid.
// Initial list: window.sfWishlist (snippets/custom-sf-head.liquid), items of
// { v: variantId, p: productId }. Saving goes through the app proxy
// /apps/wishlist (Cloudflare Worker, sfs-wishlist repo), which updates the
// customer's custom.wishlist metafield and returns the new list.
(function () {
  var ENDPOINT = '/apps/wishlist';
  var PAGE_URL = '/pages/swym-wishlist';
  // Guests see no hearts (as with Swym); window.sfWishlist is only set for
  // logged-in customers.
  if (!window.sfWishlist) return;
  var items = window.sfWishlist.items || [];

  // ---- Algolia result cards (collections, search) ----
  // Algolia draws these in the browser, so the Liquid snippet can't add the
  // heart; add the same markup to each .ais-hit (it carries the ids).
  var HEART =
    '<svg class="sf-wishlist-btn__icon" viewBox="0 0 24 24" width="32" height="32" aria-hidden="true" focusable="false">' +
    '<path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/></svg>';

  function addHitHearts() {
    document.querySelectorAll('.ais-hit[data-product-id]:not([data-sf-wishlist-added])').forEach(function (hit) {
      hit.setAttribute('data-sf-wishlist-added', '');
      var title = (hit.querySelector('img') || {}).alt || '';
      var el = document.createElement('button');
      el.type = 'button';
      el.setAttribute('data-sf-wishlist', 'product');
      el.dataset.productId = hit.dataset.productId;
      el.dataset.variantId = hit.dataset.variantId;
      el.dataset.productTitle = title;
      el.dataset.productUrl = '/products/' + hit.dataset.handle;
      el.setAttribute('aria-label', 'Save ' + title + ' to wishlist');
      el.className = 'sf-wishlist-btn sf-wishlist-btn--overlay';
      el.innerHTML = HEART;
      hit.appendChild(el);
    });
    render();
  }

  var hitsQueued = false;
  function watchHits() {
    addHitHearts();
    new MutationObserver(function () {
      if (hitsQueued) return;
      hitsQueued = true;
      requestAnimationFrame(function () {
        hitsQueued = false;
        if (document.querySelector('.ais-hit[data-product-id]:not([data-sf-wishlist-added])')) addHitHearts();
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (/^\/(collections|search)/.test(location.pathname)) watchHits();
  // One request at a time, so quick double-taps are applied in order.
  var queue = Promise.resolve();

  // Bottom-left message after each save/remove (like Swym's notifications),
  // with the product photo when there is one.
  var toast, toastTimer;
  function notify(text, withLink, image) {
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'sf-wishlist-toast';
      toast.setAttribute('role', 'status');
      document.body.appendChild(toast);
    }
    toast.textContent = '';
    if (image) {
      var img = document.createElement('img');
      img.src = image;
      img.alt = '';
      toast.appendChild(img);
    }
    var message = document.createElement('span');
    message.textContent = text;
    if (withLink && location.pathname !== PAGE_URL) {
      var link = document.createElement('a');
      link.href = PAGE_URL;
      link.textContent = 'View';
      message.appendChild(document.createTextNode(' · '));
      message.appendChild(link);
    }
    toast.appendChild(message);
    toast.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.hidden = true; }, 5000);
  }

  function hasVariant(v) {
    return items.some(function (i) { return i.v === v; });
  }
  function hasProduct(p) {
    return items.some(function (i) { return i.p === p; });
  }

  // Product page heart: the variant currently selected in the same section.
  function currentVariant(btn) {
    var section = btn.closest('.shopify-section') || document;
    var input = section.querySelector('form[action*="/cart/add"] [name="id"]');
    return (input && input.value) || btn.dataset.variantId;
  }

  function isSaved(btn) {
    return btn.dataset.sfWishlist === 'variant'
      ? hasVariant(currentVariant(btn))
      : hasProduct(btn.dataset.productId);
  }

  function render() {
    document.querySelectorAll('button[data-sf-wishlist]').forEach(function (btn) {
      btn.setAttribute('aria-pressed', isSaved(btn) ? 'true' : 'false');
    });
    document.querySelectorAll('[data-sf-wishlist-count]').forEach(function (el) {
      el.textContent = items.length;
      el.hidden = items.length === 0;
    });
    document.querySelectorAll('[data-sf-wishlist-menu-count]').forEach(function (el) {
      el.textContent = '(' + items.length + ')';
    });
    document.querySelectorAll('[data-sf-wishlist-page-count]').forEach(function (el) {
      el.textContent = items.length + (items.length === 1 ? ' item' : ' items');
    });
  }

  // The Worker may not know a variant's product (it can't look it up
  // without read_products); keep the product id we already had, so card
  // hearts stay filled.
  function keepProducts(fresh) {
    var known = {};
    items.forEach(function (i) { if (i.p) known[i.v] = i.p; });
    return fresh.map(function (i) {
      return { v: i.v, p: i.p || known[i.v] || null };
    });
  }

  function send(body) {
    queue = queue
      .then(function () {
        return fetch(ENDPOINT, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body),
        });
      })
      .then(function (res) {
        if (!res.ok) throw new Error('wishlist ' + res.status);
        return res.json();
      })
      .then(function (data) {
        items = keepProducts(data.items || []);
      })
      .catch(function () {
        notify("Couldn't save, please try again");
        // Put the hearts back to what the server last confirmed.
        return fetch(ENDPOINT, { headers: { Accept: 'application/json' } })
          .then(function (res) { return res.ok ? res.json() : null; })
          .then(function (data) { if (data) items = keepProducts(data.items || []); })
          .catch(function () {});
      })
      .then(render);
  }

  // The photo the heart sits on (card, Algolia hit or product gallery).
  // Already loaded, so the message costs no extra download.
  function photoFor(btn) {
    for (var el = btn.parentElement; el && el !== document.body; el = el.parentElement) {
      var img = el.querySelector('img');
      if (img) return img.currentSrc || img.src;
    }
    return null;
  }

  function toggle(btn) {
    var productId = btn.dataset.productId;
    var variantId = btn.dataset.sfWishlist === 'variant' ? currentVariant(btn) : btn.dataset.variantId;

    if (isSaved(btn)) {
      // Cards remove every saved variant of the product; the product page
      // removes just the selected one. Send the variant ids, which the page
      // knows, so the Worker doesn't have to work out the product.
      var removing = btn.dataset.sfWishlist === 'variant'
        ? [variantId]
        : items.filter(function (i) { return i.p === productId; }).map(function (i) { return i.v; });
      items = items.filter(function (i) { return removing.indexOf(i.v) === -1; });
      send({ action: 'remove', variant_ids: removing, product_id: productId });
      notify('Removed from wishlist', false, photoFor(btn));
    } else {
      items = items.concat({ v: variantId, p: productId });
      send({ action: 'add', variant_id: variantId });
      notify('Added to wishlist', true, photoFor(btn));
      if (window.klaviyo) {
        window.klaviyo.track('Added to Wishlist', {
          ProductID: Number(productId),
          VariantID: Number(variantId),
          Name: btn.dataset.productTitle,
          URL: location.origin + btn.dataset.productUrl,
        });
      }
    }
    render();
  }

  // Wishlist page: ⋮ menu > Remove from list.
  function removeFromPage(btn) {
    var variantId = btn.dataset.variantId;
    items = items.filter(function (i) { return i.v !== variantId; });
    send({ action: 'remove', variant_id: variantId });

    var card = btn.closest('[data-sf-wishlist-item]');
    var list = card && card.parentNode;
    if (card) card.remove();
    if (list && !list.querySelector('[data-sf-wishlist-item]')) {
      var empty = document.querySelector('[data-sf-wishlist-empty]');
      if (empty) empty.hidden = false;
    }

    notify('Item Removed');
    render();
  }

  // Wishlist page: ⋮ > "Clear wishlist" asks once, then removes everything.
  function clearStep(el) {
    var area = el.closest('[data-sf-wishlist-clear-area]');
    var ask = area.querySelector('[data-sf-wishlist-clear]');
    var confirm = area.querySelector('[data-sf-wishlist-clear-confirm]');
    if (el.hasAttribute('data-sf-wishlist-clear')) {
      ask.hidden = true;
      confirm.hidden = false;
    } else if (el.hasAttribute('data-sf-wishlist-clear-no')) {
      closeMenu(area);
    } else {
      items = [];
      send({ action: 'clear' });
      document.querySelectorAll('[data-sf-wishlist-item]').forEach(function (card) { card.remove(); });
      var empty = document.querySelector('[data-sf-wishlist-empty]');
      if (empty) empty.hidden = false;
      area.remove();
      notify('Wishlist cleared');
      render();
    }
  }

  // Close a ⋮ menu, putting "Clear wishlist" back if it was asking to confirm.
  function closeMenu(menu) {
    menu.open = false;
    var ask = menu.querySelector('[data-sf-wishlist-clear]');
    var confirm = menu.querySelector('[data-sf-wishlist-clear-confirm]');
    if (ask) ask.hidden = false;
    if (confirm) confirm.hidden = true;
  }

  document.addEventListener(
    'click',
    function (e) {
      if (!e.target.closest) return;
      // A click anywhere outside an open ⋮ menu closes it.
      document.querySelectorAll('details.sf-wishlist__menu[open]').forEach(function (menu) {
        if (!menu.contains(e.target)) closeMenu(menu);
      });
      var clear = e.target.closest('[data-sf-wishlist-clear], [data-sf-wishlist-clear-yes], [data-sf-wishlist-clear-no]');
      if (clear) {
        e.preventDefault();
        clearStep(clear);
        return;
      }
      var remove = e.target.closest('[data-sf-wishlist-remove]');
      var heart = !remove && e.target.closest('button[data-sf-wishlist]');
      if (!remove && !heart) return;
      // Hearts sit on top of product-card links.
      e.preventDefault();
      e.stopPropagation();
      if (remove) removeFromPage(remove);
      else toggle(heart);
    },
    true
  );

  // Product page: the selected variant changes without a reload.
  document.addEventListener('change', function (e) {
    if (e.target.closest && e.target.closest('variant-picker, .variant-picker, form[action*="/cart/add"]')) {
      setTimeout(render, 400);
    }
  });

  render();
})();
